var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLinkAppointment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67280)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.627 0.00195312C15.972 0.00216272 16.252 0.281904 16.252 0.626953V1.25195H17.502C18.8825 1.25216 20.002 2.37137 20.002 3.75195V17.502C20.0017 18.8823 18.8823 20.0017 17.502 20.002H2.50195C1.1214 20.002 0.0022061 18.8825 0.00195312 17.502V3.75195C0.00195312 2.37124 1.12124 1.25195 2.50195 1.25195H3.75195V0.626953C3.75195 0.281775 4.03177 0.00195312 4.37695 0.00195312C4.72195 0.00216272 5.00195 0.281904 5.00195 0.626953V1.25195H15.002V0.626953C15.002 0.281775 15.2818 0.00195312 15.627 0.00195312ZM3.18359 3.75195C2.80704 3.75195 2.50195 4.03177 2.50195 4.37695V5.62695C2.50223 5.97192 2.80721 6.25195 3.18359 6.25195H16.8193C17.1957 6.25195 17.5017 5.97192 17.502 5.62695V4.37695C17.502 4.03177 17.1959 3.75195 16.8193 3.75195H3.18359Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkAppointment);
export default __webpack_public_path__ + "static/media/nav-link-appointment.68ccf4197d2e47f665aeb3cb4c9a5ff6.svg";
export { ForwardRef as ReactComponent };